export function basename(path: string, ext?: string): string {
  if (typeof path !== "string") {
    return "";
  }

  let start = 0;
  let end = -1;
  let matchedSlash = true;
  let i;

  // Find the end of the last path component
  for (i = path.length - 1; i >= 0; --i) {
    const code = path.charCodeAt(i);
    if (code === 47 /* / */ || code === 92 /* \ */) {
      if (!matchedSlash) {
        start = i + 1;
        break;
      }
    } else if (end === -1) {
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) {
    return "";
  }

  let base = path.slice(start, end);

  // If an extension is provided, and it matches, remove it
  if (ext && base.endsWith(ext) && ext !== "") {
    base = base.slice(0, -ext.length);
  }

  return base;
}
